import { create } from "zustand";
import { clearTokens, setTokens, isAuthed } from "../../utils/tokenCookie";

interface AuthState {
  isLoggedIn: boolean;
  setLogin: (accessToken: string, refreshToken?: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isLoggedIn: isAuthed(),
  setLogin: (accessToken, refreshToken) => {
    setTokens(accessToken, refreshToken);
    set({ isLoggedIn: true });
  },
  logout: () => {
    clearTokens();
    set({ isLoggedIn: false });
  },
}));
